import { useNavigate } from '@tanstack/react-router';
import { RefObject } from 'react';
import { PatientSummaryDto } from '../../../../api/generated/model';
import { VirtualTablePaddingRow } from '../../../../components/table/VirtualTablePaddingRow.tsx';
import { useCustomVirtualizer } from '../../../../hooks/useCustomVirtualizer.ts';
import { PATIENT_TABLE_CELL_HEIGHT } from '../../../../theme.ts';
import { getCaseManagementStatusName } from '../../../../utils/caseManagement.ts';
import { getTbType } from '../../../../utils/clinicalReport.ts';
import { PatientTable } from './PatientTable.tsx';
import { PatientTablePatientInfosData, PatientTablePatientInfosHeader } from './PatientTablePatientInfos.tsx';

export function PatientsScreeningTable({
  patients,
  parentRef,
}: {
  patients: PatientSummaryDto[];
  parentRef: RefObject<HTMLElement | null>;
}) {
  const navigate = useNavigate();

  const { virtualItems, totalSize, paddingTop, paddingBottom } = useCustomVirtualizer({
    count: patients.length,
    cellHeight: PATIENT_TABLE_CELL_HEIGHT,
    parentRef: parentRef,
  });

  return (
    <PatientTable stickyHeader borderAxis="xBetween" noWrap hoverRow>
      <thead>
        <tr>
          <PatientTablePatientInfosHeader />
          <th>Selbstzahler</th>
          <th>MLB</th>
          <th>MKB</th>
          <th>TB</th>
        </tr>
      </thead>
      <tbody style={{ height: totalSize }}>
        <VirtualTablePaddingRow height={paddingTop} />

        {virtualItems.map((virtualRow) => {
          const patient = patients[virtualRow.index];
          return (
            <tr
              key={virtualRow.index}
              onClick={() => navigate({ to: '/patients/$patientId', params: { patientId: patient.id } })}>
              <PatientTablePatientInfosData patient={patient} />
              <td>{getCaseManagementStatusName(patient.directPayer)}</td>
              <td>{patient.countLabReports}</td>
              <td>{patient.clinicalReport ? 'Ja' : 'Nein'}</td>
              <td>{patient.clinicalReport && getTbType(patient.clinicalReport?.organs)}</td>
            </tr>
          );
        })}
        <VirtualTablePaddingRow height={paddingBottom} />
      </tbody>
    </PatientTable>
  );
}
